<div class="table-main-container" *ngIf="graph && barGraph">
    <div class="graphs-table-main-container">
        <div class="channel-graph-container">
            <div class="axis-setting-container">
                <div class="axis-setting-header">
                    <div class="axis-title">
                        {{ 'graph.bar.table.axis-setting.title' | translate }}
                    </div>
                    <div class="axis-text">
                        {{ 'graph.bar.table.axis-setting.text' | translate }}
                    </div>
                </div>

                <div class="dropdowns-container">
                    <div class="dropdowns-sub-container">
                        <div class="dropdown-text">
                            {{ 'graph.bar.table.axis-setting.measuring-range-format' | translate }}
                        </div>
                        <div class="dropdown-wrapper">
                            <div
                                #rangeDropdownButton
                                class="dropdown range-dropdown"
                                [class.focus]="isRangeDropdownOpen"
                                (click)="toggleRangeDropdown()">
                                {{ getSelectedRangeLabel() | translate }}
                                <mat-icon class="arrow" svgIcon="dropdown-arrow" [class.focus]="isRangeDropdownOpen">
                                </mat-icon>
                            </div>
                            <div #rangeDropdown class="dropdown-menu" *ngIf="isRangeDropdownOpen">
                                <div
                                    *ngFor="let option of axisMeasuringRangeOptions"
                                    class="dropdown-item"
                                    (click)="onSelectRange(option.value); $event.stopPropagation()">
                                    <mat-radio-button
                                        class="radio-icon"
                                        [checked]="barGraph.displayType === option.value"
                                        [value]="option.value"
                                        color="primary"></mat-radio-button>
                                    <span class="option-label">{{ option.translate | translate }}</span>
                                    <div class="info-icon-wrapper">
                                        <mat-icon
                                            svgIcon="info"
                                            class="info-icon"
                                            (mouseenter)="hoveredOption = option.value"
                                            (mouseleave)="hoveredOption = null"></mat-icon>

                                        <ng-container *ngIf="hoveredOption === option.value">
                                            <div
                                                #infoMessage
                                                class="info-message-container"
                                                [innerHTML]="getInfoMessage(option.value)"></div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="dropdowns-sub-container">
                        <div class="dropdown-text">
                            {{ 'graph.bar.table.axis-setting.reference-lines-count' | translate }}
                        </div>
                        <div class="reference-dropdown-wrapper">
                            <app-simple-dropdown
                                #referenceDropdown
                                class="line-count-dropdown"
                                [options]="axisMeasuringReferenceOptions"
                                [selectedOption]="this.barGraph.divisions"
                                [width]="120"
                                (onOptionSelected)="onSelectReference($event.value)">
                            </app-simple-dropdown>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-wrapper">
                <div class="header-container">
                    <div class="header-title">
                        <div>
                            {{ 'graph.bar.table.channels.title' | translate }}
                        </div>
                        <div class="add-row-container">
                            <div class="slots-text">
                                {{
                                    'graph.bar.table.channels.slots'
                                        | translate: { slots: barGraph.channels?.length, max: maxChannelSlots }
                                }}
                            </div>
                            <div
                                class="add-row-button"
                                [class.disable]="!showAddNewChannel()"
                                (click)="addChannelRow()">
                                {{ 'graph.bar.table.button.add-row' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-container">
                    <app-bar-graph-table-header style="width: 100%"></app-bar-graph-table-header>
                    <div class="table-content">
                        <div class="no-channel-text" *ngIf="barGraph.channels?.length === 0">
                            {{ 'graph.no-channels.text.bar' | translate }}
                        </div>
                        <ng-container *ngIf="barGraph.channels">
                            <app-bar-graph-table-row
                                *ngFor="let channel of barGraph.channels; let i = index"
                                [rowIndex]="i"
                                [channel]="channel"
                                [vesselId]="graph.vesselId"
                                [optionsVisible]="selectedRowIndex === i"
                                (onOptionsToggled)="optionsToggled(i)"
                                (onDeleteRow)="deleteChannelRow(i)"></app-bar-graph-table-row>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-confirmation-window
    #cancelConfirmation
    [mainLabel]="'graph.cancel.dialog.title'"
    [discardLabel]="'graph.cancel.dialog.discard'"
    [goBackLabel]="'graph.cancel.dialog.go-back'"
    [saveLabel]="'graph.cancel.dialog.save'"></app-confirmation-window>
